import { renderPage } from "renderPage"
import { ClubGiftIndexPage } from "./Page"

renderPage({ component: ClubGiftIndexPage })
